import type { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { PageHeader } from '../../components/atlas/PageHeader';
import { PipelineHojeBlock } from './blocks/PipelineHojeBlock';
import { KpiSnapshotBlock } from './blocks/KpiSnapshotBlock';
import { CampaignsLiveBlock } from './blocks/CampaignsLiveBlock';

function greeting(name?: string): string {
  const h = new Date().getHours();
  const time = h < 12 ? 'Bom dia' : h < 18 ? 'Boa tarde' : 'Boa noite';
  if (!name) {
    return time;
  }
  const firstName = name.split(' ')[0];
  return `${time}, ${firstName}`;
}

function blocksForRole(role: string): ReactNode[] {
  if (role === 'ADMIN') {
    return [
      <KpiSnapshotBlock key="kpi" />,
      <CampaignsLiveBlock key="camp" />,
      <PipelineHojeBlock key="pipe" />,
    ];
  }
  if (role === 'MANAGER') {
    return [
      <KpiSnapshotBlock key="kpi" />,
      <PipelineHojeBlock key="pipe" />,
      <CampaignsLiveBlock key="camp" />,
    ];
  }
  // SELLER (default)
  return [
    <PipelineHojeBlock key="pipe" />,
    <CampaignsLiveBlock key="camp" />,
    <KpiSnapshotBlock key="kpi" />,
  ];
}

function subtitleForRole(role: string): string {
  if (role === 'ADMIN') {
    return 'Visão executiva do CRM.';
  }
  if (role === 'MANAGER') {
    return 'Olhada rápida no time e na receita.';
  }
  return 'Vamos focar nos leads de hoje.';
}

export default function HojePage() {
  const { user } = useAuth();
  const role = user?.role ?? 'SELLER';

  const eyebrow = new Date().toLocaleDateString('pt-BR', {
    weekday: 'long',
    day: '2-digit',
    month: 'long',
  });

  return (
    <div className="p-6 md:p-8 max-w-6xl mx-auto">
      <PageHeader eyebrow={eyebrow} title={greeting(user?.name)} subtitle={subtitleForRole(role)} />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">{blocksForRole(role)}</div>
    </div>
  );
}
